import ApiCall from "utils/apiCall";
import { buildUtmPayload } from "utils/utmPayload";
import { clearAllClickIds } from "utils/clickIds";

const initialState = {
  isFetching: false
};

// Reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "utm.isFetching":
      return { ...state, isFetching: true };

    case "utm.fetchSuccess":
      return { ...state, isFetching: false };

    case "utm.fetchError":
      return { ...state, isFetching: false };

    default:
      return state;
  }
}

// Actions
// The click IDs are cleared only once the API has the attribution: saved now, or
// already saved for this store (422, e.g. by sign-up checkout). On any other
// failure they are kept for the next attempt.
export function sendUtm() {
  return dispatch => {
    const payload = buildUtmPayload();
    if (!payload) return Promise.resolve();

    dispatch({ type: "utm.isFetching" });
    return ApiCall.post(`/stores/utm`, payload)
      .then(() => {
        clearAllClickIds();
        dispatch({ type: "utm.fetchSuccess" });
      })
      .catch(error => {
        if (error?.status === 422) clearAllClickIds();
        dispatch({ type: "utm.fetchError", error });
      });
  };
}
